import { render } from "./SectionReference.vue?vue&type=template&id=f8b6f8f6&scoped=true"
import script from "./SectionReference.vue?vue&type=script&lang=js"
export * from "./SectionReference.vue?vue&type=script&lang=js"

import "./SectionReference.vue?vue&type=style&index=0&id=f8b6f8f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b6f8f6"]])

export default __exports__